import { jsxs as o, jsx as s } from "react/jsx-runtime";
import { Icon as n } from "../../Icon/Icon.js";
const c = "FormGenericErrorMessage-module_error__TN4Mn",
  i = "FormGenericErrorMessage-module_icon__93W6M",
  r = {
    error: c,
    icon: i
  },
  t = _ref => {
    let {
      message: e
    } = _ref;
    return /* @__PURE__ */o("div", {
      className: r.error,
      children: [/* @__PURE__ */s(n, {
        name: "alert",
        padding: !1,
        className: r.icon
      }), e]
    });
  };
export { t as FormGenericErrorMessage };